import React from 'react';
import {
	CreateButton,
	ExportButton,
	TopToolbar,
	sanitizeListRestProps,
	useListContext,
	usePermissions
} from 'react-admin';

import { DeviationsExportModal, DeviationsExportWithFilters } from '../../../components/dialogs/DeviationsExportDialog';
import { AppRoles } from '../../../entities';
import { isInArray } from '../../../utils/general';

export const DeviationsActions = (props) => {
    const { className, exporter, filters, ...rest } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext(props);
	const { permissions } = usePermissions();
    const isAccessToExport = permissions && (isInArray(AppRoles, permissions.role));
    return React.useMemo(
        () => (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                {filters &&
                    React.cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: 'button',
                    })}
              
                {isAccessToExport && <DeviationsExportWithFilters filters={filterValues} />}
                {isAccessToExport && <DeviationsExportModal />}
                {hasCreate && <CreateButton basePath={basePath} />}
            </TopToolbar>
        ),
        [resource, displayedFilters, filterValues, selectedIds, filters, total, permissions] 
    );
}
